/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC Content Calculator (DNA / RNA) — Toolverse`)
};

const es_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Contenido GC (ADN / ARN) — Toolverse`)
};

const de_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-Gehalt-Rechner (DNA / RNA) — Toolverse`)
};

const nl_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-gehaltecalculator (DNA / RNA) — Toolverse`)
};

const fr_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de contenu GC (ADN / ARN) — Toolverse`)
};

const it_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore del contenuto GC (DNA / RNA) — Toolverse`)
};

const pt_br2_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Conteúdo GC (DNA / RNA) — Toolverse`)
};

const pt_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Conteúdo GC (ADN / ARN) — Toolverse`)
};

const ja_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC含量計算ツール (DNA / RNA) — Toolverse`)
};

const zh_gc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 含量计算器（DNA / RNA）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_meta_title", locale)
	if (locale === "en") return en_gc_meta_title(inputs)
	if (locale === "es") return es_gc_meta_title(inputs)
	if (locale === "de") return de_gc_meta_title(inputs)
	if (locale === "nl") return nl_gc_meta_title(inputs)
	if (locale === "fr") return fr_gc_meta_title(inputs)
	if (locale === "it") return it_gc_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_gc_meta_title(inputs)
	if (locale === "pt") return pt_gc_meta_title(inputs)
	if (locale === "ja") return ja_gc_meta_title(inputs)
	return zh_gc_meta_title(inputs)
};